export default "__VITE_ASSET__K1M6OuwQ__"